import React from 'react';
import { trustPoints, siteConfig } from '../mock';
import { useBooking } from '../hooks/useBooking';
import useSEO from '../hooks/useSEO';
import { Sparkles } from 'lucide-react';

const About = () => {
  useSEO({
    title: 'Meist — Prestige Beauty & Wellness Pärnus',
    description:
      'Prestige Beauty & Wellness on kohapeal Pärnus, kus tipptasemel LPG Alliance tehnoloogia kohtub personaalse hoolitsuse ja rahuliku keskkonnaga.',
    path: '/meist',
  });
  const openBooking = useBooking();

  return (
    <div>
      <section className="pt-28 pb-16 px-6 text-center" style={{ backgroundColor: '#ffffff' }}>
        <div className="about-hero-logo mx-auto fade-up">
          <img
            src={siteConfig.heroImage}
            alt="PRESTIGE Beauty & Wellness"
            className="hero-logo-photo select-none"
            draggable="false"
            loading="eager"
            decoding="async"
            width={1254}
            height={1254}
          />
        </div>
      </section>

      <section className="bg-ivory py-20 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="section-eyebrow">Meie lugu</div>
          <h2 className="font-serif-display text-3xl md:text-4xl text-brand mt-4">
            Teaduslik lähenemine ilule
          </h2>
          <div className="mt-4 flex justify-center"><span className="gold-divider" /></div>

          <p className="text-ink-soft mt-8 leading-relaxed text-left md:text-center">
            Prestige Beauty &amp; Wellness sündis soovist luua koht, kus tipptasemel
            kehahooldused kohtuvad hoolivuse, professionaalsuse ja personaalse
            lähenemisega.
          </p>
          <p className="text-ink-soft mt-4 leading-relaxed text-left md:text-center">
            Meie teekond sai alguse kirest aidata inimestel tunda end oma kehas hästi.
            Aastate jooksul oleme pidevalt täiendanud oma teadmisi ning toonud Pärnusse
            maailmas tunnustatud LPG Alliance Cellu M6 tehnoloogia, ühendades selle
            klassikalise massaaži ja kaasaegsete kehahooldustega.
          </p>
          <p className="text-ink-soft mt-4 leading-relaxed text-left md:text-center">
            Usume, et ilu ei seisne täiuslikkuses, vaid enesetundes. Seetõttu
            koostame iga hooldusplaani vastavalt kliendi soovidele ja eesmärkidele,
            et saavutada loomulikud, nähtavad ja kestvad tulemused.
          </p>
          <p className="text-ink-soft mt-4 leading-relaxed text-left md:text-center">
            Täna on Prestige Beauty &amp; Wellness koht, kus kohtuvad tipptasemel
            tehnoloogia, rahulik keskkond ja siiras soov pakkuda igale kliendile
            personaalset hoolitsust. Meie jaoks on kõige olulisem, et iga inimene
            lahkuks siit enesekindlama, lõõgastunuma ja rõõmsamana kui saabudes.
          </p>

          <button className="btn-gold mt-10" onClick={openBooking}>
            Broneeri aeg
          </button>
        </div>
      </section>

      <section className="bg-ivory-2 py-24 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center">
            <div className="section-eyebrow">Miks meie</div>
            <h2 className="section-title text-3xl md:text-4xl mt-4">Kliendid usaldavad meid</h2>
            <div className="mt-6 flex justify-center"><span className="gold-divider" /></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10 mt-16">
            {trustPoints.map((p, i) => (
              <div key={i} className="flex gap-5">
                <div className="feature-icon">
                  <Sparkles className="w-4 h-4" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-brand text-lg font-serif-display">{p.title}</h3>
                  <p className="text-brand-muted mt-2">{p.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
